import { AvailableActions, IDataQueryState } from '../actions/dataQuery'
import { combineReducers } from "redux"
import { updateState } from "../StoreFactory"
import {ActionType} from "../../interfaces/storeFactory";



export interface IDataQueryStore {
    dataQuery: IDataQueryState
}


export const initialState = {
    dataQuery: {
        dateRanges: [[`${(new Date).getFullYear() - 1}-01-01`, `${(new Date).getFullYear()- 1}-12-31`]],
        allDataSeries: [{
            type: "dataset",
            dataSeriesParams: [],
            transformations: [],
            availableTransformations: []
        }],
        locationSelectionMode: 'locationSearch',
        customPolygon: undefined,
        geonameIds: undefined,
        utcOffset: '+00:00',
        timeSelectionMode: "timeIntervals",
        startDateMonth: '1',
        startDateDay: '1',
        startDateNumDays: '30',
        startDateYears: '2015, 2016, 2017',
        startDateYearsValues: [2015,2016,2017],
        startDateYearsIsValid: true,
        fillGapsWith: "none",
        timeIntervalsAlignment: "none",
        shareString: undefined,
        locations: [{ key: "7.57327/47.558399/279%Basel%0", label: "Basel, Canton of Basel-City, CH" }],
        coordsListParsed: [],
        coordsDatesListParsed: [],
        timeIntervalsListParsed: [],
        temperatureUnit: 'C',
        windspeedUnit: 'km/h',
        lengthUnit: 'metric',
        energyUnit: 'watts',
        combineLocationsAndTimes: false,
        outputFormat: 'highcharts',
        downloadFormat: 'csv',
        excludeSeaPoints: false,
        includeNeighbours: false
    }
}

const reducers = {
    dataQuery: (previousState=initialState.dataQuery, action: ActionType<any>) => {
        let supportedActions: string[] = [];
        for (let action of  Object.values(AvailableActions)){
            supportedActions.push(action)
        }
        return updateState(previousState, action, supportedActions)
    }
}

export default combineReducers(reducers)